/**
 * Returns localized string according to the passed number value.
 *
 * Example:
 * value 1 yields 'one item'
 * value 6 yields 'six items'
 *
 * see test file for better example: src\utilities\__tests__\format\pluralize.test.ts
 */
const pluralize = (value, localization) => {
    if (!localization) {
        return '';
    }

    if (value === 1) return localization.one;
    if ([2, 3, 4].includes(value)) return localization.twoToFour;
    return localization.fiveOrMore;
};

export default pluralize;
